import { useEffect, useState } from "react";
import { EditDemoScenarioForm } from "@/components/demo/EditDemoScenarioForm";
import { useParams } from "react-router";
import type { DemoScenarioWithFormattedCodes } from "@/types/demo";
import { log } from "@/utils/debug";

export default function EditDemoScenario() {
  const { id } = useParams<{ id: string }>();
  const [initialData, setInitialData] = useState<DemoScenarioWithFormattedCodes | undefined>();

  useEffect(() => {
    // Try to get initial data from session storage
    const storedData = sessionStorage.getItem("editScenario");
    if (storedData && id) {
      try {
        const parsedData = JSON.parse(storedData) as DemoScenarioWithFormattedCodes;
        if (parsedData.id === id) {
          setInitialData(parsedData);
          log.process("Loaded edit scenario data from session storage", { id });
        }
      } catch (error) {
        log.error("Failed to parse stored scenario data", error);
      }
    }
  }, [id]);

  if (!id) {
    return (
      <div className="container mx-auto py-6">
        <h1 className="text-2xl font-bold">Error: No scenario ID provided</h1>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6 space-y-8">
      <h1 className="text-2xl font-bold">Edit Demo Scenario</h1>
      <EditDemoScenarioForm scenarioId={id} initialData={initialData} />
    </div>
  );
}
